'use client';

import { useEffect } from 'react';
import { useParams } from 'next/navigation';

import { getQuizApi } from '../api/quiz.api';
import { useQuizStore } from '../model/store';

export const useActiveQuiz = () => {
  const { moduleId } = useParams<{ moduleId: string }>();

  const quizId = useQuizStore((state) => state.quizId);
  const setQuizId = useQuizStore((state) => state.setQuizId);
  const setQuiz = useQuizStore((state) => state.setQuiz);

  useEffect(() => {
    if (!moduleId) {
      setQuizId(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [moduleId]);

  useEffect(() => {
    if (quizId === 'result') {
      setQuiz(undefined);
      return;
    }

    if (!quizId) {
      setQuiz(undefined);
    } else {
      getQuizApi({ id: quizId })
        .then((data) => {
          setQuiz(data);
        })
        .catch(() => {
          setQuiz(undefined);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quizId]);
};
